// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const eelektrik: PokeData = {
  "id": 603,
  "name": "eelektrik",
  "height": 12,
  "weight": 220,
  "base_experience": 142,
  "types": [
    PokeType.ELECTRIC
  ],
  "api_moves": [
    "bind",
    "headbutt",
    "thrash",
    "acid",
    "thunderbolt",
    "thunder-wave",
    "zap-cannon",
    "spark",
    "crunch",
    "gastro-acid",
    "discharge",
    "charge-beam",
    "coil",
    "acid-spray",
    "wild-charge"
  ],
  "moves": [
    "headbutt",
    "acid",
    "thunderbolt",
    "zap-cannon",
    "crunch",
    "wild-charge",
    "electric-wrath",
    "volt-crash",
    "thunder",
    "thunder-punch",
    "thunder-shock",
    "thunder-fang",
    "quick-tempo"
  ],
  "evolution_chain": {
    "id": 306,
    "item": null,
    "species": [
      {
        "name": "tynamo",
        "order": 603,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "eelektrik",
        "order": 604,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": 602,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 39,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "eelektross",
        "order": 605,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": 603,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "thunder-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 67.5,
    "speed": 40,
    "ability_power": 85
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
